export const rules = {
    patient_id: [
        { required: true, message: 'Пожалуйста, выберите пациент ', trigger: 'change' },
    ],
   
};
